import { useState, useEffect, useMemo } from "react";
import { extractSearchablePages, filterPagesByUserRole, searchPages } from "utils/pageSearchData";
import sessionHelper from "services/sessionHelper";

export const usePageSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Get all pages that user has access to
  const userPages = useMemo(() => {
    const allPages = extractSearchablePages();
    return filterPagesByUserRole(allPages, sessionHelper);
  }, []);

  // Filter and search pages based on search term
  const filteredPages = useMemo(() => {
    return searchPages(userPages, searchTerm);
  }, [userPages, searchTerm]);

  // Reset selected index when search results change
  useEffect(() => {
    setSelectedIndex(0);
  }, [filteredPages]);

  // Global keyboard shortcut to open search
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      // Open search with Ctrl+K or Cmd+K
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        setIsOpen(true);
        return;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const openSearch = () => {
    setIsOpen(true);
    setSearchTerm("");
    setSelectedIndex(0);
  };

  const closeSearch = () => {
    setIsOpen(false);
    setSearchTerm("");
    setSelectedIndex(0);
  };

  const handleSearchChange = (event: any) => {
    setSearchTerm(event.target.value);
  };

  return {
    isOpen,
    searchTerm,
    filteredPages,
    selectedIndex,
    openSearch,
    closeSearch,
    handleSearchChange,
    setSelectedIndex
  };
};